export default "__VITE_ASSET__BZKSdu4V__"